import { render } from "./FormAuthorityConfig.vue?vue&type=template&id=ac7e5798&scoped=true&ts=true"
import script from "./FormAuthorityConfig.vue?vue&type=script&lang=ts"
export * from "./FormAuthorityConfig.vue?vue&type=script&lang=ts"

import "./FormAuthorityConfig.vue?vue&type=style&index=0&id=ac7e5798&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac7e5798"]])

export default __exports__